


























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SzksCompleteDialog extends Vue {
  @Prop()
  private ifVisible: any;
  @Prop()
  private result;
  private get visible() {
    return this.ifVisible;
  }
  private set visible(val) {
    this.$emit("update:ifVisible", val);
  }
  private jumpResult() {
    this.$router.replace({
      path: "/main/szjx/szks-result",
      query: {
        id: this.result.exam_id,
      },
    });
  }
  private jumpList() {
    this.$router.replace({
      path: "/main/szjx/szks-list",
    });
  }
}
